import { Component, HostListener, input, InputSignal, signal } from '@angular/core';
import { MatCell, MatColumnDef, MatHeaderCell, MatHeaderRow, MatRow, MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TransformUnderscoreToSpacePipe } from '../../pipes/tranform-underscore-to-space.pipe';
import { NgClass, NgStyle, TitleCasePipe } from '@angular/common';

export type EmptyTableColumnWidthConfig = {
  base: number;
  xl?: number;
  lg?: number;
  md?: number;
  sm?: number;
  visibility?: 'hidden';
};

@Component({
  selector: 'app-empty-table',
  imports: [
    MatTableModule,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatRow,
    NgClass,
    TransformUnderscoreToSpacePipe,
    TitleCasePipe,
    NgStyle
  ],
  templateUrl: './empty-table.component.html',
  styleUrl: './empty-table.component.scss'
})
export class EmptyTableComponent {
  emptyTable = [{}, {}, {}, {}, {}];
  readonly dataSource: MatTableDataSource<any> = new MatTableDataSource<any>(this.emptyTable);

  readonly displayedColumns: InputSignal<string[]> = input.required<string[]>();
  readonly columnWidth: InputSignal<number | undefined> = input.required<number | undefined>();
  readonly columnWidthResponsiveMap: InputSignal<Record<string, EmptyTableColumnWidthConfig> | undefined> = input<
    Record<string, EmptyTableColumnWidthConfig> | undefined
  >();
  readonly tableClass: InputSignal<string | undefined> = input<string | undefined>();

  readonly cellWidth: InputSignal<boolean> = input<boolean>(false);

  private viewportWidth = signal<number>(typeof window !== 'undefined' ? window.innerWidth : 1920);

  @HostListener('window:resize')
  onResize(): void {
    this.viewportWidth.set(window.innerWidth);
  }

  getWidth(column: string): number | undefined {
    const cfg = this.getColumnConfig(column);
    const base = this.columnWidth();

    if (cfg) {
      const w = this.viewportWidth();
      if (w < 768 && cfg.sm != null) return cfg.sm;
      if (w < 1024 && cfg.md != null) return cfg.md;
      if (w < 1280 && cfg.lg != null) return cfg.lg;
      return cfg.base ?? base;
    }

    return base;
  }

  private getColumnConfig(column: string): EmptyTableColumnWidthConfig | undefined {
    return this.columnWidthResponsiveMap()?.[column];
  }

  getSpanVisibility(column: string): 'visible' | 'hidden' | 'collapse' | null {
    const v = this.getColumnConfig(column)?.visibility;
    return v ?? null;
  }
}
